var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7665 2.81352C14.7118 -0.180879 9.12343 -0.148091 5.10228 2.91188L9.43034 7.23994C10.979 6.40311 12.8498 6.37693 14.4186 7.1614L18.7665 2.81352ZM7.20687 9.4925L2.87087 5.1565C-0.148335 9.17355 -0.167457 14.73 2.81351 18.7665L7.16139 14.4187C6.38738 12.8708 6.40254 11.0289 7.20687 9.4925ZM20.9925 4.97834L16.6812 9.28956C17.6232 10.914 17.6495 12.9238 16.7601 14.5697L21.0881 18.8977C24.2128 14.7916 24.1809 9.05118 20.9925 4.97834ZM18.8435 21.1291L14.5075 16.7931C12.8734 17.6487 10.8936 17.6114 9.28955 16.6813L4.97833 20.9925C9.03327 24.1669 14.7411 24.2125 18.8435 21.1291Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoans);
export default __webpack_public_path__ + "static/media/loans.1266828db90581734c4a3151309627bd.svg";
export { ForwardRef as ReactComponent };